module.exports = __webpack_public_path__ + "static/img/patrick-chindo.6c3707e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/patrick-chindo.png
// module id = Q7JE
// module chunks = 0